
import {DEFAULT_STATE_VALUE,ALL_STONES} from '../constants';
import {getValueFromDictArray} from '../reducers/utils'
export   function getSize(in1) {
const sizes= {"1":["1","41","13.1"],
"2":["2","41.5","13.3"],
"2.5":["3","42.9","13.7"],
"3":["5","43.6","13.9"],
"3.5":["6","46.1","14.7"],
"4":["7","47.4","15.1"],
"4.5":["8","48","15.3"],
"5":["10","50","15.9"],
"5.5":["11","51.2","16.3"],
"6":["12","51.9","16.5"],
"6.5":["13","53.1","16.9"],
"7":["14","54.4","17.3"],
"7.5":["15","55.1","17.5"],
"8":["17","57","18.1"],
"8.5":["18","58.3","18.5"],
"9":["20","60.2","19.2"],
"9.5":["21","60.8","19.4"],
"10":["22","62.1","19.8"],
"10.5":["23","62.7","20"],
"11":["25","64.6","20.6"],
"11.5":["26","65.9","21"],
"12":["28","67.8","21.6"],
"12.5":["29","69.1","22"],
"13":["30","69.7","22.2"],
"13.5":["31","71","22.6"]}
 return sizes[in1]
}
export  default function getDescription2 (state) {
  var res=[];
  const flowerName = {
    "6370":["garnet","Carnation","January"],
"7773":["amethyst","Violet","February"],
"6372":["aquamarine","Daffodil","March"],
"6373":["white topaz","Daisy","April"],
"6375":["emerald","Hawthorn","May"],
"6377":["alexandrite","Rose","June"],
"6376":["ruby","Waterlily","July"],
"6374":["peridot","Poppy","August"],
"7774":["sapphire","Morning Glory","September"],
"6379":["opal","Cosmos","October"],
"6380":["citrine","Chrysanthemum","November"],
"7909":["blue topaz","Poinsettia","December"]

  }
  const propertyName = {
    d:'Design',
    i:'Letter',
    c:'Center Stone',
    s1:'Stone 1',
    s2:'Stone 2',
    s3:'Stone 3',
    s4:'Stone 4',
    s5:'Stone 5',
    s6:'Stone 6',
    s7:'Stone 7',
    s8:'Stone 8',
    s9:'Stone 9',
    s10:'Stone 10',
    a1:'Stone 1',
    a2:'Stone 2',
    a3:'Stone 3',
    a4:'Stone 4',
    a5:'Stone 5',
    a6:'Stone 6',
    a7:'Stone 7',
    a8:'Stone 8',
    a9:'Stone 9',
    a10:'Stone 10',
    m: 'Metal',
    e: 'Engraving Text Line ',
    rs: 'Ring Size',
    cl:'Chain Length',
    bl:'Bracelet Length',
    Height: 'Height',
    Width: 'Width',
    'Earring Type': 'Earring Type',
    Diamond: 'Diamond',
  }
  const valueName = {
    s:'925 Sterling Silver',
    spy:'18K Yellow Gold Plated Over Sterling Silver',
    spr:'18K Gold Rose Plated Over Sterling Silver',
    t:'Titanium',
    ss:'Stainless Steel',
    g10y:'Gold 10K Yellow',
    g14y:'Gold 14K Yellow',
    g18y:'Gold 18K Yellow',
    g10w:'Gold 10K White',
    g14w:'Gold 14K White',
    g18w:'Gold 18K White',
    g10r:'Gold 10K Rose',
    g14r:'Gold 14K Rose',
    g18r:'Gold 18K Rose',
    am:"Amethyst",
    al:"Alexandrite",
    aq:"Aquamarine",
    bt:"Blue Topaz",
    bo:"Black Onyx",
    ci:"Citrine",
    em:"Emerald",
    gr:"Garnet",
    ga:"Green Quartz",
    gs:"Green Sapphire",
    op:"Opal",
    pe:"Peridot",
    ps:"Pink Sapphire",
    ru:"Ruby",
    sa:"Sapphire",
    sq:"Smoky Quartz",
    wt:"White Topaz",
    I1: 'I1 - I2',
    I2: 'I2 - I3',
    I3: 'I3',
  }
  let addFont = false
  let curProp;
  let curValue;
  let finalValue;
  let all_options_plus_default = state['options_all'].slice()
  let default_options =['m','bl','cl']  
   for (let new_opt in default_options) {
     if (state[default_options[new_opt]] !== DEFAULT_STATE_VALUE && state['options_all'].indexOf(default_options[new_opt])  === -1) {
       all_options_plus_default.push(default_options[new_opt])
     }

  }
 //console.log('all',all_options_plus_default)
 //console.log('REVIEW STATE',state)
  
  for (let key in all_options_plus_default)
  {
    // if (key.indexOf('options_') === -1)
   // res =res+key+':'+ state[key]+ ' '
   var keyValue=all_options_plus_default[key]
   if (( state.hasOwnProperty('options_' + keyValue) === true && state['options_' + keyValue].show === false) ||
        state[keyValue] === DEFAULT_STATE_VALUE) 
      continue
   if (ALL_STONES.indexOf(keyValue)  !== -1) {
     // process all stones
    if (propertyName.hasOwnProperty(keyValue))
      curProp = propertyName[keyValue]
    else
      curProp = state['options_'+keyValue].name  
    curValue =state[keyValue]
    var stoneQuality =getValueFromDictArray(state['options_' + keyValue].options,'value',curValue,'quality')
    if (stoneQuality !== "L") {
        stoneQuality = ' '
    }
    else {
      stoneQuality = ' Lab-Created ' 
    }
    //console.log('arelem',keyValue)

    if (valueName.hasOwnProperty(curValue))
        curValue = valueName[curValue]
    if  (state['options_' + keyValue].hasOwnProperty('description')){    
    let val =state['options_' + keyValue].description.split('|') 
    if (state['cs_details'].hasOwnProperty(state['sku'])){
      if (state['cs_details'][state['sku']].hasOwnProperty(keyValue)){
       let dyn_desc_arr= state['cs_details'][state['sku']][keyValue]
       for (var arrelem in dyn_desc_arr){
        let dyn_desc =dyn_desc_arr[arrelem] 
       // console.log('arelem',arrelem,dyn_desc_arr)
        //let dyn_desc =arrelem
        val[1]=dyn_desc['qty']
        val[2]= dyn_desc['size']
        val[3]= dyn_desc['shape']
        finalValue = '('+val[1] +') '+ val[2]+'mm '+ val[3] + stoneQuality +curValue 
        if (val[4] !== '') 
          finalValue+= ' stone in a '+ val[4] + ' setting'
        else 
          finalValue+= ' stone'
          if (dyn_desc_arr.length >1)
            res.push({property:'Stone',value:finalValue})
          else  
            res.push({property:curProp,value:finalValue})
        }
      }
    }  
    }
   }
   else if (keyValue === 'cl' ||keyValue === 'bl' ) {
    curProp = propertyName[keyValue]
    curValue =state[keyValue]
    finalValue = curValue + ' inch (' + Math.round(parseFloat(curValue)*2.54).toString() + ' cm)'
    if (state.hasOwnProperty('options_' + keyValue)){
      let val =state['options_' + keyValue].description.split('|') 
      
      finalValue +=' '+val[0]
      if (val.length > 1) 
        finalValue+=' with secure '+ val[1]
    }
    else if (state['desc_clasp'] !== '') {
      finalValue+=' with secure '+ state['desc_clasp']
      if (keyValue ==='bl')
      if (state['desc_clasp']==='bolo'){
        if (curValue ==='8.5')
         finalValue = '8 1/2 inch (21 cm) with secure '+ state['desc_clasp']
         if (curValue ==='7')
         finalValue = '7 inch (18 cm) with secure '+ state['desc_clasp']
      }
    } 
    res.push({property:curProp,value:finalValue})
  }
   else if (keyValue === 'sc') {
    curProp = state['options_sc'].name
    curValue =state[keyValue] //.toUpperCase()
    res.push({property:curProp,value:curValue})
     
   }
   else if (keyValue === 'i') {
    curProp = propertyName[keyValue]
    curValue =state[keyValue].toUpperCase()
    res.push({property:curProp,value:curValue})
     
   }
   else if (keyValue === 'rs') {
    var s= getSize(state[keyValue])
    curProp = propertyName[keyValue]
    curValue =state[keyValue]  + ' (US), ' + s[0] + ' (India)' 
    res.push({property:curProp,value:curValue})
    curProp = 'Ring Diameter'
    curValue = + s[2] + ' MM' 
    res.push({property:curProp,value:curValue})
    curProp = 'Ring Circumference'
    curValue = + s[1] + ' MM' 
    res.push({property:curProp,value:curValue})
    
   }
   else if (keyValue === 'd' && state.style==="6370") {
    curProp = propertyName[keyValue]
    curValue =flowerName[state["sku"]][1].toUpperCase()
    res.push({property:curProp,value:curValue})
    
    curProp = "Stone"
    curValue =flowerName[state["sku"]][0].toUpperCase()
    res.push({property:curProp,value:curValue})
     
   }

  else if (keyValue === 'd') {
  /*  curProp = propertyName[keyValue]
    curValue =state[keyValue].toUpperCase()
    res.push({property:curProp,value:curValue})*/
     
   }
   
   else if (['e','f'].indexOf(keyValue)  === -1) {
    if (state[keyValue] !== DEFAULT_STATE_VALUE) {
      //console.log('not e-f',keyValue,state[keyValue],propertyName)
      if (propertyName.hasOwnProperty(keyValue))
        curProp = propertyName[keyValue]
      else
        curProp = state['options_'+keyValue].name  
      curValue =state[keyValue]
      if (curProp.indexOf('Letter')  === -1 && valueName.hasOwnProperty(curValue))
        curValue = valueName[curValue]
        
      // console.log('stae now',curProp,curValue); 
      res.push({property:curProp,value:curValue})
    }  
   }

  //console.log('state now',key); 
  }
  if (state.hasOwnProperty('options_e')) {
   for (let i in state['options_e'].options) {
    // console.log('e option',i,state['e'+(parseInt(i)+1).toString()],propertyName['e'] +' '+ (parseInt(i)+1).toString())
      if (state['e'+(parseInt(i,10)+1).toString()] !== undefined && state['e'+(parseInt(i,10)+1).toString()] !== ''){
       res.push({property:propertyName['e'] +' '+ (parseInt(i,10)+1).toString(),value:state['e'+(parseInt(i,10)+1).toString()]})
       addFont = true
      }

    }

    if (addFont) {
      let fontName=''
      switch (state['f']) {
        case "0":
          fontName='Regular'
          break;
          case "1":
          fontName='Script'
          break;
          case "2":
          fontName='Monogram Circle'
          break;
          case "3":
          fontName='Monogram Vine'
          break;
          case "h":
          fontName='Hindi'
          break;
        default:
        fontName=''
        break;
      }
    res.push({property:'Font',value:fontName})

    }
  }
  var w= '3.2'
  //console.log('review',state,state['m']+'-'+ state.sku)
  var met='s'
  if (state['m'] ==='t') met='t'
  if (state['m'] ==='ss') met='ss'
  
  if (state.hasOwnProperty('total_m_weight')  )
   w= state['total_m_weight']
   var extra=0
   if (state.sku ==='4792')
      extra=0.34
   if (state.sku ==='2201' || state.sku ==='2205')
      extra=0.27
   if (extra !== 0)  
    w = (parseFloat(w) + extra*state['e1'].length).toString()
  if (met ==='s')
   res.push({property:'Weight', value:w +' gram' })

  if (state.hasOwnProperty('desc_static_stones')){
     var static_st=state['desc_static_stones'][state.sku]
     for (let i1 in static_st) {
   //   console.log('i1',i1)
      res.push({property:i1, value:static_st[i1]+ ' MM' })
     }
  }

  //  console.log('state',state)
  if (state.hasOwnProperty('options_description')) {
    for (let i in state['options_description'].options) {
       //console.log('review',state['options_description'].options[i])
       switch (state['options_description'].options[i].name) {
         case 'Diamond':
          let val =state['options_description'].options[i].value.split('|')
          if (state['cs_details'].hasOwnProperty(state['sku']+'-ctw')){
             let dyn_desc= state['cs_details'][state['sku']+'-ctw']
              val[1]=dyn_desc
          }  

          if (state['cs_details'].hasOwnProperty(state['sku']+'-ctwqty')){
            let dyn_desc= state['cs_details'][state['sku']+'-ctwqty']
             val[0]=dyn_desc
          }  
         let finalVal ='('+val[0]+') '+val[1]+' ct tw. round diamonds in a ' + val[3] + ' setting. Quality - '
          //+ valueName[val[2]] +'. Color - H-I. Diamond Total Carat Weight may range from ' 
          + valueName[val[2]] +'. Color - H-I. ' 
          //+  diamond_minmax(val[1]) +' carats.'
          res.push({property:'Diamond',value:finalVal})
          break;
         case 'Height':
          if (state.hasOwnProperty('sku_heights'))
           res.push({property:propertyName[state['options_description'].options[i].name], value:state['sku_heights'][state.sku] + ' MM' })
          else 
           res.push({property:propertyName[state['options_description'].options[i].name], value:state['options_description'].options[i].value + ' MM' })
          break;
         case 'Width':
          res.push({property:propertyName[state['options_description'].options[i].name], value:state['options_description'].options[i].value + ' MM' })
          break;
         case 'Earring Type':
          res.push({property:propertyName[state['options_description'].options[i].name], value:'Secured with ' + state['options_description'].options[i].value + ' backs' })
          break;
       
         default:
          res.push({property:propertyName[state['options_description'].options[i].name],value:state['options_description'].options[i].value})
          break;
       }
       
 
     }
  }
  //console.log('REVIEW STATE',state)
 
  return res;
  
  }



// WEBPACK FOOTER //
// ./src/reducers/getDescription2.js